import {urlParam} from "./urlParam";

export const utmProps = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
  'roistat', 'roistat_visit', 'roistat_referrer', 'roistat_pos'];

// добавление к ссылкам utm-меток
export const linkWithUtm = (link) => {
  let result = link,
    urlParts = window.location.href.split('?'),
    utmString = (urlParts.length > 1 && urlParts[1] != '') ? urlParts[1].split('#')[0] : ''

  if (link.includes('https://fitron.club') && utmString != '') {
    result += (link.includes('?') ? '&' : '?') + utmString
  }

  return result
}

export const saveUtmToStorage = () => {
  utmProps.forEach((propname) => {
    let value = urlParam(propname);
    if (value !== null && value !== '') {
      sessionStorage.setItem(propname, value);
    }
  });
}

export const getUtmFromStorage = () => {
  const utmParams = {};
  utmProps.forEach((propname) => {
    let value = sessionStorage.getItem(propname);
    if (value !== null && value !== '') {
      utmParams[propname] = value;
    }
  });

  return Object.values(utmParams).length ? utmParams : null;
}

export const pushUrlWithUtm = async (params) => {
  if(!params)
    params = getUtmFromStorage();

  const urlParams = new URLSearchParams(window.location.search);

  for(const [propname, value] of Object.entries(params)) {
    if (value !== null && value !== '') {
      urlParams.set(propname, value);
    }
  }

  window.history.pushState({}, '', '?' + (new URLSearchParams(urlParams)).toString() + (window.location.hash ? window.location.hash : ''))
}
